import { h, render, Component } from 'preact';

class TxrNavSubmenuResources extends Component {
    state = {
    }
    render() {
        return (
            <div class="txr-nav-submenu resources">
                <div class="submenu-mobile-back" onClick={() => this.props.onClose()}>
                    <img class="submenu-mobile-back__icon" src="/images/navigation/icon-arrow-nav.svg"></img>
                    <span class="submenu-mobile-back__text">Resources</span>
                </div>
                <div class="txr-nav-submenu-content">
                    <div class="submenu-left">
                        <div class="submenu-nav">
                            <a class="submenu-nav-item" href="/resources/all">
                                <i class="submenu-nav-item__icon fal fa-angle-right"></i>
                                <span class="submenu-nav-item__link">View all Resources</span>
                            </a>
                            <div class="submenu-nav__line"></div>
                        </div>
                        <div class="submenu-menus">
                            <a class="submenu-item" href="/resources/case-studies">
                                <img class="submenu-item__image image-width23" alt="sumbenu" src="/images/navigation/icon-case-studies-new.svg" />
                                <img class="submenu-item__image-hover image-width23" alt="sumbenu" src="/images/navigation/icon-case-studies-new-green.svg" />
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Case Studies
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/resources/ebooks">
                                <i class="submenu-item__image-icon fal fa-book-heart"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Ebooks & Reports
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/resources/insights">
                            <img class="submenu-item__image image-width23" alt="sumbenu" src="/images/navigation/icon-insights-new.svg" />
                             <img class="submenu-item__image-hover image-width23" alt="sumbenu" src="/images/navigation/icon-insights-new-green.svg" />
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Insights
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/resources/message-templates">
                                <i class="submenu-item__image-icon fal fa-file-heart"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Message Templates
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/resources/newsletters">
                                <i class="submenu-item__image-icon fal fa-pencil"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Newsletters
                                    </div>
                                </div>
                            </a>                            
                            <a class="submenu-item" href="/resources/playbooks">
                                <i class="submenu-item__image-icon font19 fal fa-hand-sparkles"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Playbooks
                                    </div>
                                </div>
                            </a>

                        </div>
                    </div>
                    <div class="submenu-right">
                        <div class="submenu-menus">
                            <a class="submenu-item submenu-item__only-mobile" href="https://help.textrequest.com" target="_blank">
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Help Center
                                    </div>
                                </div>
                            </a>                            
                            <a class="submenu-help-center" href="https://help.textrequest.com" target="_blank">
                                <i class="submenu-item__image-icon fal fa-book-sparkles"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Help Center
                                    </div>
                                    <div class="submenu-item__text">
                                    Guides, documentation, and resources to help you master Text Request.
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrNavSubmenuResources;